export default function(x) {
  return (0.05859375 * x * x * (1 + 0.75 * x));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/e2fn.js
// module id = 32
// module chunks = 0